export default __webpack_public_path__ + "static/media/removed-from-blacklist.2b3b3a10.svg";